<template>
  <div :class="{ [customDefault]: avatarUrl === emptySrc || !src }">
    <img :src="avatarUrl" :width="width" :height="height" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: 'CustomImage',
  props: {
    emptySrc: {
      type: String,
      default: '',
    },

    src: {
      type: String,
      default: '',
    },

    width: {
      type: String,
      default: '',
    },

    height: {
      type: String,
      default: '',
    },

    alt: {
      type: String,
      default: '',
    },

    customDefault: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      avatarUrl: this.emptySrc,
    };
  },

  watch: {
    src() {
      this.getCandidateAvatar();
    },
  },

  mounted() {
    this.getCandidateAvatar();
  },

  methods: {
    getCandidateAvatar() {
      const img = document.createElement('img');

      img.src = this.src;

      img.onload = () => {
        this.avatarUrl = this.src;
      };

      img.onerror = () => {
        this.avatarUrl = this.emptySrc;
      };
      if (img) img.remove();
    },
  },
};
</script>

<style scoped>
.bg-default {
  width: 28px;
  height: 28px;
  background: #d8d8d8;
}
.bg-default img {
  display: none;
}
img {
  max-width: 100%;
  object-fit: cover;
}
</style>
